import { Box, Grid, styled } from '@grupoboticario/flora-react';

import { Skeleton } from 'components';

const style = {
  SkeletonTracking: styled(Skeleton, {
    height: 'calc($23 * 3)',

    '@tablet': {
      height: '$23',
    },
  }),

  Wrapper: styled(Box, {
    gridColumn: '1/-1',
  }),

  StatusWrapper: styled(Grid, {
    display: 'flex',
    flexFlow: 'column',
    width: '100%',

    '@tablet': {
      alignItems: 'start',
      display: 'grid',
      gridTemplateColumns: 'repeat(6, 1fr)',
    },
  }),
};

export default style;
